/* GOWin® Store — quantity keyboard fix v1 */
(() => {
  if (window.GowinCartQtyRuntimeFixV1) return;
  window.GowinCartQtyRuntimeFixV1 = true;

  const CUSTOM_INPUT = '.gowin-cart-qty-inline__custom';
  const REAL_INPUT = '.cart-item__quantity .quantity__input';
  const suppressedInputs = new WeakSet();

  const notifyCartUpdated = (state, line, quantity, variantId) => {
    if (!state || state.errors) return;
    const detail = {
      cart: state,
      cartData: state,
      line,
      quantity,
      variantId,
      source: 'gowin-quantity-keyboard',
    };

    document.dispatchEvent(new CustomEvent('cart:updated', { detail, bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail, bubbles: true }));
  };

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    /* Suppress only the synthetic Dawn change emitted by the legacy custom-input handler. */
    if (target.matches(REAL_INPUT) && !event.isTrusted && suppressedInputs.has(target)) {
      event.stopImmediatePropagation();
      suppressedInputs.delete(target);
      return;
    }

    if (!target.matches(CUSTOM_INPUT)) return;

    const nextQty = parseInt(target.value || '', 10);
    if (!Number.isFinite(nextQty) || nextQty <= 0) return;

    const row = target.closest('.cart-item');
    const realInput = row?.querySelector(REAL_INPUT);
    const cartItems = row?.closest('cart-drawer-items');
    const line = parseInt(realInput?.dataset?.index || '', 10);
    const variantId = realInput?.dataset?.quantityVariantId;

    if (!realInput || !cartItems || typeof cartItems.updateQuantity !== 'function' || !Number.isInteger(line) || line < 1) {
      return;
    }

    /* Mark before the legacy handler runs, so its synthetic change can't create a second update. */
    suppressedInputs.add(realInput);

    window.setTimeout(() => {
      if (!realInput.isConnected || !cartItems.isConnected) return;

      realInput.value = String(nextQty);
      const syntheticEvent = new Event('change', { bubbles: false, cancelable: true });
      const result = cartItems.updateQuantity(line, nextQty, syntheticEvent, null, variantId);

      if (result && typeof result.then === 'function') {
        result
          .then((state) => notifyCartUpdated(state, line, nextQty, variantId))
          .catch(() => {});
      }
    }, 0);
  }, true);
})();
